<template>
  <div ref="dynamiclist">
    <div class="dynamictopbg">

      <div class="fixtopbox">
        <div class="backbtn">
          <backbtn></backbtn>
        </div>
      </div>

      <div class="topfixbox" v-show="topfixshow">
        <span><img v-if="dynamiccontent.avatar_url" :src="dynamiccontent.avatar_url" /><img v-else :src="avatar_url" /></span>
      </div>

      <div class="dynamictopbox">
        <div class="dynamictopmain" style="padding-top:2rem">

          <div class="dynamictop-pic" v-if="dynamiccontent.avatar_url">
            <img :src="dynamiccontent.avatar_url" />
          </div>
          <div class="dynamictop-pic" v-else>
            <img :src="avatar_url" />
          </div>

          <div class="dynamictop-name" v-if="dynamiccontent.name">{{dynamiccontent.name}}
            <div class="dynamictop-dj" v-if="dynamiccontent.gradeInfo">
              <img src="../../assets/images/circle_icon_denji.png"></img>
              <span>{{dynamiccontent.gradeInfo.grade}}</span>
            </div>
          </div>
          <div class="dynamictop-name" v-else>默认名称</div>

          <div class="dynamictop-funs"><span>关注 {{dynamiccontent.followers_num}}</span> <span>粉丝 {{dynamiccontent.fans_num}}</span></div>
        </div>
      </div>

      <img src="../../assets/images/tx_bg.png" />

    </div>

    <div class="dynamiclist">
      <slot></slot>
      <van-sticky :offset-top="70">
        <div class="dynamictab">
          <ul>
            <li :class="dqactive == 0 ? 'active' : ''" @click="goalldynamic"><span>全部动态({{alltotal}})</span></li>
            <li :class="dqactive == 1 ? 'active' : ''" @click="goimgdynamic"><span>图文动态</span></li>
            <li :class="dqactive == 2 ? 'active' : ''" @click="govideodynamic"><span>视频动态</span></li>
            <li :class="dqactive == 3 ? 'active' : ''" @click="gocircledynamic"><span>圈子动态</span></li>
          </ul>
        </div>
      </van-sticky>

      <div class="nodynamiclist" v-if="nodynamic || dynamiclistdata.length==0">
        <div class="nofollowpic"><img :src="nodynamicpic" />
          <p>暂无动态</p>
        </div>
        <div class="gotofollow" @click="gotopublish" v-if="dynamiclistdata.is_own==1"><button>立即去发布</button></div>
      </div>
      <div v-else>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div v-for="(item,index) in dynamiclistdata" :key="index">
            <dynamiclist :dynamiclistdata="item" :allnamiclistdata="dynamiclistdata" :alldynamiccnum="dynamiccontent.totalCount" :dylistindex="index" :isown="dynamiccontent.is_own" :isdytemple="isdytemple"></dynamiclist>
          </div>
        </van-list>
      </div>
    </div>

    <div class="dydownnavbox" v-if="dynamiccontent.is_own == 1">
      <div class="dydownnavmain">
        <div class="down-pulishbtn" @click="gotopublish">
          <img :src="publishicon" /><span>发布动态</span>
        </div>

        <div class="down-sharebtn">
          <button class="dy-sharebtn" @click="showPopup" v-clipboard:copy="config.link"><img :src="shareicon" /><span>分享转发</span></button>
        </div>

        <div class="down-tacartbtn" @click="gototacart(dynamiccontent.api_uid)">
          <img :src="mycaricon" /><span>我的名片</span>
        </div>
      </div>

    </div>

    <div class="dydownnavbox" v-else>
      <div class="dydownnavmain">
        <div class="down-followbtn">
          <div class="dy-followbtn active" @click="followpeople(dynamiccontent.api_uid)" v-if="dynamiccontent.is_follow==1"><img :src="followicon01" /><span>已关注</span></div>
          <div class="dy-followbtn" @click="followpeople(dynamiccontent.api_uid)" v-else><img :src="followicon02" /><span>+ 关注</span> </div>
        </div>

        <div class="down-sharebtn">
          <button class="dy-sharebtn" @click="showPopup" v-clipboard:copy="config.link"><img :src="shareicon" /><span>分享转发</span></button>
        </div>

        <div class="down-tacartbtn" @click="gototacart(dynamiccontent.api_uid)">
          <img :src="mycaricon" /><span>Ta的名片</span>
        </div>

      </div>
    </div>

    <!--分享到-->
    <van-popup v-model="showpopup" position="bottom" :style="{ height: '50%' }">
      <div class="sharedownbox">
        <vue-native-share :shareMenu="shareMenu" :config="config" />
      </div>
      <van-button class="sharetopbox" @click="closepopup" type="default" block>取消分享</van-button>
    </van-popup>

  </div>
</template>

<script>
import { getmydynamic, getfollowpeople, getcircledylist } from "../../api/api";
import { Toast } from 'vant';
import vueNativeShare from '../plugins/vue-native-share'
import dynamiclist from "../public/dynamiclist";
import Bus from "@/assets/js/bus.js";
import axios from "axios";
import backbtn from "../public/backbtn";
export default {
  name: "dynamic",
  components: {
    dynamiclist,
    backbtn,
    vueNativeShare
  },
  data () {
    return {
      list: [],
      dqactive: 0,
      showpopup: false,
      topfixshow: false,
      isdytemple: true, //表示是动态的模板
      dynamiccontent: {},
      avatar_url: require("../../assets/images/moren.jpg"),
      followicon01: require("../../assets/images/dynamic_btn_attention_selected.png"),
      followicon02: require("../../assets/images/dynamic_btn_attention_normal.png"),
      publishicon: require("../../assets/images/dynamic_icon_release.png"),
      shareicon: require("../../assets/images/dynamic_icon_share.png"),
      mycaricon: require("../../assets/images/dynamic_icon_business.png"),
      nodynamicpic: require("../../assets/images/circle_icon_wu.png"),
      dynamiclistdata: [], //动态列表
      newdynamiclistdata: [],
      alltotal: 0,
      page: 0, //分页请求
      pageCount: 0,
      msg_type: 0,
      loading: false,
      scrollTop: 0,
      finished: true,
      nodynamic: false,
      shareMenu: [0, 1, 2, 3],
      otherrenid: '',
      config: {
        title: '鲜枇杷名片-动态',
        desc: '免费为企业/个人制作电子名片，扫描二维码生成你的专属电子名片',
        img: "https://api.xianpipa.com/xianpipa/images/logo.png",
        img_title: '一款名片应用',
        link: '当前链接',
        success: () => { console.log('success') },
        cancel: () => { console.log('cancel') },
      }
    };
  },

  beforeRouteEnter (to, from, next) {
    if (from.name == 'dynamicdetails') { // 这个name是下一级页面的路由name        
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next()
    //to.meta.keepAlive = true;
  },

  created () {
    document.title = '动态';
    window.scrollTo(0, 0);
    let that = this;
    var otherrenid = '';
    const toastloading = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    if (this.$route.query.otherrenid) {
      otherrenid = this.$route.query.otherrenid;
      this.otherrenid = this.$route.query.otherrenid;
    }
    getmydynamic(otherrenid).then(res => {
      if (res.data.code == 200) {
        that.dynamiccontent = res.data.data;
        that.dynamiclistdata = res.data.data.list;
        that.newdynamiclistdata = res.data.data.list;
        that.alltotal = res.data.data.totalCount;
        that.loading = false;
        that.pageCount = res.data.data.pageCount;
        that.finished = false;
        that.otherrenid = res.data.data.api_uid;
        var url =
          window.location.host + "/#/dynamic?otherrenid=" + that.otherrenid;
        that.config.link = url;
        toastloading.clear();

        if (res.data.data.totalCount > 0) {

          that.nodynamic = false;

        } else {

          that.nodynamic = true;
        }


      } else {

        that.nodynamic = true;
        Toast.fail('数据异常，请刷新！');

      }
    }).catch(err => {
    });

  },

  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
    //bus传值
    this.jieshou();
  },
  methods: {
    showPopup () {
      if (/micromessenger/i.test(navigator.userAgent)) {
        //微信复制链接
        Toast.success({
          duration: 2000,
          message: "链接已复制，快去分享吧！"
        });

      } else {
        this.showpopup = true;
      }
    },
    closepopup () {
      this.showpopup = false;
    },
    jieshou () {
      Bus.$on("alldynamiccnum", res => {
        this.alltotal = res;
      });
    },
    gotopublish () {
      this.$router.push({
        name: 'publish'
      })
    },
    gototacart (e) {
      if (this.dynamiccontent.is_own == 1) {
        this.$router.push({
          name: 'mindex'
        })

      } else {
        let id = e;
        this.$router.push({
          path: '/othercart',
          query: {
            id: id
          }
        })

      }

    },
    onLoad () {
      // 异步更新数据 
      let that = this;

      setTimeout(() => {
        let api_uid = this.dynamiccontent.api_uid;
        var page = this.page;
        //let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page > pageCount) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.page = page;

        let msg_type = that.msg_type;

        getmydynamic(api_uid, msg_type, page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let dynamiclistarr = that.dynamiclistdata;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              dynamiclistarr.push(e);
            });
          }
        });
      }, 500);
    },

    //全部动态
    goalldynamic () {
      this.dqactive = 0;
      let otherrenid = this.dynamiccontent.api_uid;
      let msg_type = 0;
      this.msg_type = 0;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getdynamiclist(otherrenid, msg_type);
    },
    goimgdynamic () {
      this.dqactive = 1;
      let otherrenid = this.dynamiccontent.api_uid;
      let msg_type = 1;
      this.msg_type = 1;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getdynamiclist(otherrenid, msg_type);
    },
    govideodynamic () {
      this.dqactive = 2;
      let otherrenid = this.dynamiccontent.api_uid;
      let msg_type = 2;
      this.msg_type = 2;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getdynamiclist(otherrenid, msg_type);
    },
    gocircledynamic () {
      this.dqactive = 3;
      let otherrenid = this.dynamiccontent.api_uid;
      let msg_type = 3;
      this.msg_type = 3;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getdynamiclist(otherrenid, msg_type);
    },


    getdynamiclist (otherrenid, msg_type) {

      window.scrollTo(0, 0);

      let that = this;
      let page = 0;
      getmydynamic(otherrenid, msg_type, page).then(res => {
        if (res.data.code == 200) {
          that.dynamiccontent = res.data.data;
          that.dynamiclistdata = res.data.data.list;
          that.newdynamiclistdata = res.data.data.list;
          that.loading = false;
          that.pageCount = res.data.data.pageCount;
          that.finished = false;
          that.otherrenid = res.data.data.api_uid;


          if (res.data.data.totalCount > 0) {

            that.nodynamic = false;

          } else {

            that.nodynamic = true;
          }


        } else {

          that.nodynamic = true;
          Toast.fail('数据异常，请刷新！');

        }
      });


    },
    handleScroll () {
      var top = Math.floor(
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageXOffset
      );

      if (top > 156) {
        this.topfixshow = true;
      } else {
        this.topfixshow = false;
      }
    },

    //关注人
    followpeople (e) {
      let userid = e;
      let that = this;
      let isfollow = this.dynamiccontent.is_follow;
      //let circleid = this.circleid;
      //let dynamiccontent = this.data.dynamiccontent;
      getfollowpeople(userid).then(res => {
        if (res.code == 200) {
          if (isfollow == 0) {
            this.dynamiccontent.is_follow = 1
            isfollow = 1;
          } else {
            this.dynamiccontent.is_follow = 0;
            isfollow = 0;
          }
        } else if (res.code == 412) {
          wx.showToast({
            title: res.message,
            icon: 'none',
            duration: 2000
          })
        } else {
          wx.showToast({
            title: '网络错误',
            icon: 'none',
            duration: 2000
          })
        }
      })
    }
  },

  activated () {
    document.title = '动态';
    const toastloading = Toast.loading({
      mask: true,
      message: '加载中...'
    });
    let that = this;
    var otherrenid = '';
    var msg_type = this.msg_type;
    this.page = 0;
    if (this.$route.query.otherrenid) {
      otherrenid = this.$route.query.otherrenid;
      this.otherrenid = this.$route.query.otherrenid;
    }
    getmydynamic(otherrenid, msg_type).then(res => {
      if (res.data.code == 200) {
        that.dynamiccontent = res.data.data;
        that.dynamiclistdata = res.data.data.list;
        that.newdynamiclistdata = res.data.data.list;
        that.alltotal = res.data.data.totalCount;
        that.loading = false;
        that.pageCount = res.data.data.pageCount;
        that.finished = false;
        toastloading.clear();


        if (res.data.data.totalCount > 0) {

          that.nodynamic = false;

        } else {

          that.nodynamic = true;
        }


      } else {

        that.nodynamic = true;
        Toast.fail('数据异常，请刷新！');

      }
    });




  }
};
</script>

<style scoped>
.dynamictopbg .van-sticky {
  position: fixed;
  width: 100%;
  z-index: -1;
  background: #fff;
  padding-top: 20px;
}
.dynamictopbg .van-sticky--fixed {
  background: #fff;
  height: 1rem;
  width: 100%;
}
.fixtopbox {
  width: 100%;
  z-index: -1;
  background: none;
}
.topfixbox {
  position: fixed;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 4rem;
  background: rgba(255, 255, 255, 0.85);
  text-align: center;
}
.topfixbox span {
  padding-top: 0.85rem;
  display: inline-block;
}
.topfixbox span img {
  width: 1.8rem;
  border-radius: 50%;
}
.dynamictopbg {
  position: relative;
  overflow: hidden;
  height: 11.2rem;
}
.dynamictopbg img {
  width: 100%;
}
.backbtn {
  padding-left: 0.8rem;
  position: fixed;
  z-index: 50;
  top: 0.7rem;
}
.dynamictopbg .dynamictopbox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
}
.dynamictopbg .dynamictopbox .dynamictop-pic {
  text-align: center;
}

.dynamictopbox .dynamictopmain .dynamictop-pic img {
  width: 4.267rem;
  height: 4.267rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.38);
}
.dynamictopbox .dynamictopmain .dynamictop-name {
  color: #fff;
  text-align: center;
  padding-top: 0.53rem;
  font-size: 0.92rem;
}
.dynamictopbox .dynamictopmain .dynamictop-dj {
  display: inline-block;
  width: 17px;
  height: 18px;
  position: relative;
  top: 2px;
}

.dynamictopbox .dynamictopmain .dynamictop-name .dynamictop-dj img {
  width: 19px;
  height: 19px;
  position: absolute;
  top: 0;
  left: 0;
}

.dynamictopbox .dynamictopmain .dynamictop-name .dynamictop-dj span {
  display: inline-block;
  width: 17px;
  text-align: center;
  font-size: 12px;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 16px;
}
.dynamictopbox .dynamictopmain .dynamictop-funs {
  text-align: center;
  color: #fff;
  padding-top: 0.2rem;
}
.dynamictopbox .dynamictopmain .dynamictop-funs span {
  padding-left: 0.267rem;
  padding-right: 0.267rem;
  font-size: 0.747rem;
}

.dynamictab {
  background: #fff;
  height: 2.347rem;
  border-bottom: 1px solid #efefef;
}
.dynamictab ul {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  line-height: 2.347rem;
  height: 2.347rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.dynamictab ul li {
  font-size: 0.747rem;
  color: #666;
}
.dynamictab ul li.active {
  color: #ffbd0a;
}

.dynamiclist {
  padding-bottom: 3rem;
}

.dydownnavbox {
  position: fixed;
  z-index: 50;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #ebebeb;
  height: 2.864864864864865rem;
}
.dydownnavbox .dydownnavmain {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding-top: 0.08108108108108109rem;
  align-content: center;
}
.dydownnavbox .dydownnavmain .down-pulishbtn {
  padding-top: 0.8918918918918919rem;
  padding-right: 0.9459459459459459rem;
  padding-left: 0.40540540540540543rem;
}
.dydownnavbox .dydownnavmain .down-pulishbtn img {
  width: 0.8648648648648649rem;
  height: 0.8648648648648649rem;
  float: left;
  margin-top: 0.08108108108108109rem;
}
.dydownnavbox .dydownnavmain .down-pulishbtn span {
  float: left;
  font-size: 0.7567567567567568rem;
  padding-left: 0.5405405405405406rem;
  color: #666;
}
.dydownnavbox .dydownnavmain .down-followbtn {
  padding-top: 0.8918918918918919rem;
  padding-right: 0.9459459459459459rem;
  padding-left: 0.40540540540540543rem;
}
.dydownnavbox .dydownnavmain .down-followbtn .dy-followbtn img {
  width: 0.918918918918919rem;
  height: 0.8648648648648649rem;
  float: left;
  margin-top: 0.08108108108108109rem;
}
.dydownnavbox .dydownnavmain .down-followbtn .dy-followbtn span {
  float: left;
  font-size: 0.7567567567567568rem;
  padding-left: 0.43243243243243246rem;
  color: #666;
}
.dydownnavbox .dydownnavmain .down-followbtn .dy-followbtn.active {
  color: #ffbd0a;
}
.dydownnavbox .dydownnavmain .down-followbtn .dy-followbtn.active img {
  width: 0.918918918918919rem;
  height: 0.8648648648648649rem;
  float: left;
  margin-top: 0.08108108108108109rem;
}
.dydownnavbox .dydownnavmain .down-followbtn .dy-followbtn.active span {
  float: left;
  color: #ffbd0a;
}
.dydownnavbox .dydownnavmain .down-sharebtn {
  margin-top: 0.76rem;
  padding-right: 0.9rem;
  padding-left: 0.9rem;
  border-left: 1px solid #f3f3f3;
  border-right: 1px solid #f3f3f3;
}
.dydownnavbox .dydownnavmain .down-sharebtn img {
  width: 0.8648648648648649rem;
  height: 0.8648648648648649rem;
  float: left;
  margin-top: 0.08108108108108109rem;
}
.dydownnavbox .dydownnavmain .down-sharebtn span {
  float: left;
  font-size: 0.7567567567567568rem;
  padding-left: 0.43243243243243246rem;
}
.dydownnavbox .dydownnavmain .down-sharebtn .dy-sharebtn {
  background: none;
  line-height: 0.8648648648648649rem;
  border: none;
}
.dydownnavbox .dydownnavmain .down-sharebtn .dy-sharebtn img {
  float: left;
}
.dydownnavbox .dydownnavmain .down-sharebtn .dy-sharebtn span {
  float: left;
  color: #666;
  margin-top: 0.10810810810810811rem;
}
.dydownnavbox .dydownnavmain .down-tacartbtn {
  padding-top: 0.8648648648648649rem;
  padding-right: 0.40540540540540543rem;
  padding-left: 0.9459459459459459rem;
}
.dydownnavbox .dydownnavmain .down-tacartbtn img {
  width: 0.972972972972973rem;
  margin-top: 0.13513513513513514rem;
  height: 0.8108108108108109rem;
  float: left;
}
.dydownnavbox .dydownnavmain .down-tacartbtn span {
  float: left;
  font-size: 0.7567567567567568rem;
  padding-left: 0.43243243243243246rem;
  color: #666;
}

.sharedownbox {
  padding-top: 0rem;
}
.sharetopbox {
  position: absolute;
  bottom: 0;
}

.nodynamiclist {
  padding-top: 4.054054054054054rem;
}
.nodynamiclist .nofollowpic {
  text-align: center;
}
.nodynamiclist .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nodynamiclist .nofollowpic p {
  font-size: 0.78rem;
  color: #999;
  padding-top: 0.2rem;
}
.nodynamiclist .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.nodynamiclist .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7567567567567568rem;
  color: #fff;
  border: none;
  border-radius: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dynamic.vue